export const name = "SHA512";
export const summary = `Computes the hash of a \`STRING\` or \`BYTES\` value, using the SHA-512 algorithm.`;
export const reference = `
## SHA512

Computes the hash of a \`STRING\` or \`BYTES\` value, using the SHA-512 algorithm.

\`\`\`
SHA512(input)
\`\`\`

### Description

Computes the hash of the input using the SHA-512 algorithm. The input can either be\`STRING\` or \`BYTES\`. The string version treats the input as an array of bytes.

This function returns 64 bytes.


### Return type

\`BYTES\`


### Example



\`\`\`
SELECT SHA512("Hello World") as sha512;
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/hash_functions
`;
